module.exports = __webpack_public_path__ + "static/media/9.bd992050.png";